<template lang='pug'>
.monitoring-item-editor
  .close-container
    i.fpui.fpui-remove(@click='close()')
  .monitoring-item-editor-wrapper
    .monitoring-item-editor-container
      .header.row
        .col-xs-2
        .col-xs-8
          .row
            p.instances.col-xs-4 {{ 'fpui.monitoring.editor.size' | translate }}
            p.instances.col-xs-4 {{ 'fpui.monitoring.editor.instances' | translate }}
            p.instances.col-xs-4 {{ 'fpui.monitoring.editor.total' | translate }}
        .col-xs-2
      .content.row
        .col-xs-2
          fpui-input-select(
            v-model='selectedFpu'
            :options='fpuOptions'
            :clearable='false'
            disabled
          )
        .col-xs-8
          .row.size-editor
            .fpu.col-xs-4
              i.fpui.fpui-chevron-up.fpu-up(@click='up("fpu")')
              span.value {{ fpu }}
              i.fpui.fpui-chevron-down.fpu-down(@click='down("fpu")', :class="{ disabled: fpu == 1 }")
              span.multiply x
            .instances.col-xs-4
              i.fa.fa-minus(@click='down("instances")', :class="{ disabled: instances == 1 }")
              span.value {{ instances }}
              i.fa.fa-plus(@click='up("instances")')
            .total.col-xs-4
              span.equals =
              span.value {{ instances * fpu }}
        .col-xs-2.actions-container
          i.fpui.fpui-check.pointer(@click='save()', :class='{ disabled: saveDisabled }' v-tooltip="$t('fpui.monitoring.editor.save')")
          i.fa.fa-file-text-o.pointer(@click='logs()', v-tooltip="$t('fpui.monitoring.editor.logs')")
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import MonitoringLogs from './modals/logs/MonitoringLogs'
import MonitoringBudgetConfirm from './modals/fpu/MonitoringBudgetConfirm'

export default {
  props: {
    value: { required: true },
    fpapi: { required: true, type: Object },
    label: String
  },
  data () {
    return {
      instances: 1,
      fpu: 1,
      selectedFpu: 'fpu-s'
    }
  },
  mounted () {
    if (this.value && this.value.budget && this.value.budget.fpu) {
      this.instances = cloneDeep(this.value.budget.fpu.instances) || 1
      this.fpu = cloneDeep(this.value.budget.fpu.value) || 1
    }
  },
  computed: {
    previousFpu () { return (this.value && this.value.budget && this.value.budget.fpu && this.value.budget.fpu.value) || 1 },
    previousInstance () { return (this.value && this.value.budget && this.value.budget.fpu && this.value.budget.fpu.instances) || 1 },
    saveDisabled () {
      if (this.value && this.value.budget && this.value.budget.fpu) {
        return this.instances * this.fpu === this.previousInstance * this.previousFpu
      }
      return false
    },
    fpuOptions () {
      return [{ label: 'FPU-S', value: 'fpu-s' }]
    }
  },
  methods: {
    down (key) {
      if (this[key] > 1) this[key] -= 1
    },
    up (key) { this[key] += 1 },
    close () { this.$emit('close') },
    save () {
      if (this.saveDisabled || typeof this.fpapi.boost !== 'function') return
      let that = this
      let props = {
        asked: { fpu: this.fpu, instances: this.instances },
        before: { fpu: this.previousFpu, instances: this.previousInstance },
        label: this.label,
        save () {
          that.fpapi.boost(that.label, { fpu: that.fpu, instances: that.instances })
            .then(() => {
              this.$emit('close')
              that.$emit('input', { fpu: that.fpu, instances: that.instances })
            })
        }
      }
      this.$modal.show(MonitoringBudgetConfirm, props, { height: 'auto' })
    },
    logs () {
      this.$modal.show(MonitoringLogs, {
        services: this.value.services,
        label: this.label,
        fpapi: this.fpapi
      }, {
        height: 'auto',
        width: '80%'
      })
    }
  }
}
</script>

<style lang='less'>
  @import "~@/shared/styles/_variables.less";

  .monitoring-item-editor {
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    top: 0;
    background-color: lighten(@blue, 40%);
    .close-container {
      z-index: 2;
      position: absolute;
      right: 10px;
      font-size: 20px;
      i.fpui {
        cursor: pointer;
        color: @blue;
      }
    }
    .monitoring-item-editor-wrapper {
      // height: 100%;
      height: calc(~"100% - 20px");
      margin: 10px 0;
      padding: 0 10px;
      position: relative;
      border-left: 1px solid @grey;
      text-align: center;
      .monitoring-item-editor-container {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        .content {
          .fpui-select-box button > span {
            color: @black !important;
          }
          [class^='col-xs'] {
            height: 35px;
            line-height: 35px;
          }
        }
        .instances {
          .value {
            margin-left: 10px;
            margin-right: 10px;
          }
          i {
            border-radius: 50%;
            cursor: pointer;
            &.disabled {
              color: grey;
              cursor: not-allowed;
            }
          }
        }
        .fpu {
          position: relative;
          .fpu-up, .fpu-down {
            // color: black;
            font-size: 20px;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
          }
          .fpu-up {
            top: -12px;
          }
          .fpu-down {
            bottom: -12px;
            &.disabled {
              color: grey;
              cursor: not-allowed;
            }
          }
          .multiply {
            position: absolute;
            right: 0;
            font-size: 16px;
          }
        }
        .total {
          position: relative;
          .equals {
            position: absolute;
            left: 0;
            font-size: 16px;
          }
          .value {
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
      .actions-container {
        color: @blue;
        font-size: 20px;
        i.fpui {
          font-size: 25px;
          vertical-align: middle;
        }
        i {
          margin-left: 15px;
          &.disabled {
            color: grey;
            cursor: not-allowed;
          }
        }
      }
    }
  }
</style>
